import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '~/components';
import { useFeatures } from '~/hooks';
import { accountingProviders } from '~/lookups';
import qboIcon from '~/assets/public/qbo-icon.png';
import xeroIcon from '~/assets/public/xero-icon.png';

const icons = { qbo: qboIcon, xero: xeroIcon };

const Image = styled.img`
  width: 1rem;
  height: 1rem;
  display: block;
`;

export default function ExpenseAccountingIndicator({
  accountingProvider,
  accountingConnectionName,
  invoiceNumber,
  billNumber,
  isSynced,
}) {
  const features = useFeatures();
  if (!accountingProvider) return null;
  if (!invoiceNumber && !isSynced) return null;

  const accountingProviderName = accountingProviders[accountingProvider]?.name ?? accountingProvider;
  const location =
    features.multipleAccountingIntegrations && accountingConnectionName
      ? `the "${accountingConnectionName}" instance`
      : accountingProviderName;

  const billPart = billNumber ? `vendor bill #${billNumber}` : 'a vendor bill';

  let message;
  if (invoiceNumber && isSynced) {
    message = `This expense item is associated with invoice #${invoiceNumber} and ${billPart} in ${location}.`;
  } else if (invoiceNumber) {
    message = `This expense item is associated with invoice #${invoiceNumber} in ${location}.`;
  } else {
    message = `This expense item is associated with ${billPart} in ${location}.`;
  }

  return (
    <Tooltip message={message}>
      <Image src={icons[accountingProvider]} />
    </Tooltip>
  );
}
